import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueQr from 'vue-qr';
export default {
  name: 'QrCode',
  components: {
    VueQr: VueQr
  },
  data: function data() {
    return {
      normalizedLogoSrc: '',
      normalizeToken: 0
    };
  },
  props: {
    // 被生成二维码连接（必填）
    appSrc: {
      type: String,
      default: ''
    },
    // 二维码中间logo图片（选填）
    logoSrc: {
      type: String,
      default: ''
    },
    // 二维码尺寸（选填）
    size: {
      type: Number,
      default: 150
    },
    exportSize: {
      type: Number,
      default: 0
    },
    // 纠错等级：0=L(7%), 1=M(15%), 2=Q(25%), 3=H(30%)
    correctLevel: {
      type: Number,
      default: 3
    },
    display: {
      type: String,
      default: 'inline-block'
    }
  },
  computed: {
    renderSize: function renderSize() {
      return this.exportSize || this.size;
    },
    qrStyle: function qrStyle() {
      return {
        display: this.display,
        width: "".concat(this.size, "px"),
        height: "".concat(this.size, "px")
      };
    }
  },
  watch: {
    logoSrc: {
      immediate: true,
      handler: function handler(val) {
        this.normalizeLogo(val);
      }
    }
  },
  methods: {
    normalizeLogo: function normalizeLogo(src) {
      var _this = this;
      var token = ++this.normalizeToken;
      if (!src) {
        this.normalizedLogoSrc = '';
        return;
      }
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        if (token !== _this.normalizeToken) return;
        var side = 256;
        var canvas = document.createElement('canvas');
        canvas.width = side;
        canvas.height = side;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
          _this.normalizedLogoSrc = src;
          return;
        }
        ctx.clearRect(0, 0, side, side);
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, side, side);
        var scale = Math.min(side / img.width, side / img.height);
        var drawW = img.width * scale;
        var drawH = img.height * scale;
        var dx = (side - drawW) / 2;
        var dy = (side - drawH) / 2;
        ctx.drawImage(img, dx, dy, drawW, drawH);
        _this.normalizedLogoSrc = canvas.toDataURL('image/png');
      };
      img.onerror = function () {
        if (token !== _this.normalizeToken) return;
        // 跨域或加载失败时回退到原图，避免二维码不显示logo
        _this.normalizedLogoSrc = src;
      };
      img.src = src;
    },
    qrBack: function qrBack(data) {
      this.$emit('qrBack', data);
    }
  }
};